// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lgview {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  background: #F1F5F9;
  height: 100vh;
}

.lgpanel {
  width: 100%;
  max-width: 372px;
}

.lghead {
  text-align: center;
  margin-bottom: 26px;
}

.lgmark {
  width: 60px;
  height: 60px;
  margin: 0 auto 16px;
  border-radius: 17px;
  background: #1C6BB0;
  color: #fff;
  font-weight: 800;
  font-style: italic;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 18px rgba(28, 107, 176, 0.28);
}

.lgbrand {
  display: flex;
  justify-content: center;
  margin: 0 auto 22px;
}

.lgtitle {
  font-size: 23px;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.02em;
  color: #15212B;
}

.lgsub {
  font-size: 14px;
  color: #5C6E7D;
  margin: 6px 0 0;
}

.lgform {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.lgfield {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lgfield__lbl {
  font-size: 12.5px;
  font-weight: 600;
  color: #5C6E7D;
}

.lgfield__box {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 48px;
  padding: 0 13px;
  border: 1px solid #E4EAF0;
  border-radius: 12px;
  background: #fff;
  color: #8395A3;
  transition: all 0.13s;
}

.lgfield__box:focus-within {
  border-color: #2E86CE;
  box-shadow: 0 0 0 3px #EAF2F9;
  color: #1C6BB0;
}

.lgfield__box input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 15px;
  color: #15212B;
}

.lgfield__box input::placeholder {
  color: #8395A3;
}

.lgpeek {
  border: none;
  background: transparent;
  color: #8395A3;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  border-radius: 7px;
  transition: color 0.12s;
}

.lgpeek:hover {
  color: #1C6BB0;
}

.lglocal {
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  color: #1C6BB0;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 3px 2px;
  border-radius: 7px;
  transition: color 0.12s;
}

.lglocal svg {
  color: #5C6E7D;
}

.lglocal:hover {
  color: #1C6BB0;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.lglocal:hover svg {
  color: #1C6BB0;
}

.lgactions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 24px;
}

.lgbtn {
  height: 50px;
  border-radius: 13px;
  border: 1px solid #E4EAF0;
  background: #fff;
  color: #15212B;
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  transition: all 0.14s;
}

.lgbtn--primary {
  background: #1C6BB0;
  border-color: #1C6BB0;
  color: #fff;
  box-shadow: 0 4px 14px rgba(28, 107, 176, 0.3);
}

.lgbtn--primary:hover {
  background: #155489;
}

.lgbtn--ghost:hover {
  background: #EAF2F9;
  border-color: #B7D3EA;
  color: #1C6BB0;
}

.lgfoot {
  text-align: center;
  font-size: 11.5px;
  color: #8395A3;
  margin: 18px 0 4px;
}

.lgcheckbox {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #5C6E7D;
  cursor: pointer;
}

.lgcheckbox input {
  width: 18px;
  height: 18px;
  accent-color: #1C6BB0;
}

.lgselect {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 15px;
  color: #15212B;
  cursor: pointer;
}

.lgselect::placeholder {
  color: #8395A3;
}
`, "",{"version":3,"sources":["webpack://./src/Login.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".lgview {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 24px;\n  background: #F1F5F9;\n  height: 100vh;\n}\n\n.lgpanel {\n  width: 100%;\n  max-width: 372px;\n}\n\n.lghead {\n  text-align: center;\n  margin-bottom: 26px;\n}\n\n.lgmark {\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 16px;\n  border-radius: 17px;\n  background: #1C6BB0;\n  color: #fff;\n  font-weight: 800;\n  font-style: italic;\n  font-size: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 6px 18px rgba(28, 107, 176, 0.28);\n}\n\n.lgbrand {\n  display: flex;\n  justify-content: center;\n  margin: 0 auto 22px;\n}\n\n.lgtitle {\n  font-size: 23px;\n  font-weight: 700;\n  margin: 0;\n  letter-spacing: -0.02em;\n  color: #15212B;\n}\n\n.lgsub {\n  font-size: 14px;\n  color: #5C6E7D;\n  margin: 6px 0 0;\n}\n\n.lgform {\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n}\n\n.lgfield {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lgfield__lbl {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #5C6E7D;\n}\n\n.lgfield__box {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 48px;\n  padding: 0 13px;\n  border: 1px solid #E4EAF0;\n  border-radius: 12px;\n  background: #fff;\n  color: #8395A3;\n  transition: all 0.13s;\n}\n\n.lgfield__box:focus-within {\n  border-color: #2E86CE;\n  box-shadow: 0 0 0 3px #EAF2F9;\n  color: #1C6BB0;\n}\n\n.lgfield__box input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: 15px;\n  color: #15212B;\n}\n\n.lgfield__box input::placeholder {\n  color: #8395A3;\n}\n\n.lgpeek {\n  border: none;\n  background: transparent;\n  color: #8395A3;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  border-radius: 7px;\n  transition: color 0.12s;\n}\n\n.lgpeek:hover {\n  color: #1C6BB0;\n}\n\n.lglocal {\n  align-self: flex-end;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  background: transparent;\n  color: #1C6BB0;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 3px 2px;\n  border-radius: 7px;\n  transition: color 0.12s;\n}\n\n.lglocal svg {\n  color: #5C6E7D;\n}\n\n.lglocal:hover {\n  color: #1C6BB0;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.lglocal:hover svg {\n  color: #1C6BB0;\n}\n\n.lgactions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 24px;\n}\n\n.lgbtn {\n  height: 50px;\n  border-radius: 13px;\n  border: 1px solid #E4EAF0;\n  background: #fff;\n  color: #15212B;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  transition: all 0.14s;\n}\n\n.lgbtn--primary {\n  background: #1C6BB0;\n  border-color: #1C6BB0;\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(28, 107, 176, 0.3);\n}\n\n.lgbtn--primary:hover {\n  background: #155489;\n}\n\n.lgbtn--ghost:hover {\n  background: #EAF2F9;\n  border-color: #B7D3EA;\n  color: #1C6BB0;\n}\n\n.lgfoot {\n  text-align: center;\n  font-size: 11.5px;\n  color: #8395A3;\n  margin: 18px 0 4px;\n}\n\n.lgcheckbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #5C6E7D;\n  cursor: pointer;\n}\n\n.lgcheckbox input {\n  width: 18px;\n  height: 18px;\n  accent-color: #1C6BB0;\n}\n\n.lgselect {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: 15px;\n  color: #15212B;\n  cursor: pointer;\n}\n\n.lgselect::placeholder {\n  color: #8395A3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
